import React from "react";
import { FaRegFolderOpen, FaPlus, FaRegUser } from "react-icons/fa";
import { Link } from "react-router-dom";

const BlogAreaTwo = () => {
  return (
    <>
      {/*===================== Blog Area Two start =====================*/}
      <div className='blog-area pd-top-120 pd-bottom-90'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-8'>
              <div className='section-title text-center'>
                <h6 className='sub-title'>بلاگ‌های اخیر</h6>
                <h2 className='title'>
                آخرین اخبار و نکات تازه در دنیای گوشی‌های هوشمند 
                </h2>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-4 col-md-6'>
              <div className='single-blog-list style-2'>
                <div className='thumb'>
                  <img src='assets/img/blog/4.jpg' alt='img' />
                </div>
                <div className='details'>
                  <ul className='blog-meta'>
                    <li className='date'>۱۵ خرداد</li>
                    <li>
                      <FaRegUser /> تیم تولید محتوا 
                    </li>
                    <li>
                      <FaRegFolderOpen /> مقاله
                    </li>
                  </ul>
                  <h5 className='mb-3'>
                    <div >
                    راهنمای خرید گوشی: چگونه گوشی مورد علاقه خود را انتخاب کنید
                    </div>
                  </h5>
                  <div className='read-more-text' >
                    اطلاعات بیشتر 
                  </div>  
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='single-blog-list style-2'>
                <div className='thumb'>
                  <img src='assets/img/blog/6.jpg' alt='img' />
                </div>
                <div className='details'>
                  <ul className='blog-meta'>
                    <li className='date'>۲۰ شهریور</li>
                    <li>
                      <FaRegUser /> تیم تولید محتوا 
                    </li>
                    <li>
                      <FaRegFolderOpen /> مقاله
                    </li>
                  </ul>
                  <h5 className='mb-3'>
                    <div >
                    چرا خرید اقساطی بهترین گزینه برای تهیه گوشی هوشمند است؟
                    </div>
                  </h5>
                  <div className='read-more-text' >
                    اطلاعات بیشتر 
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='single-blog-list style-2'>
                <div className='thumb'>
                  <img src='assets/img/blog/5.jpg' alt='img' />
                </div>
                <div className='details'>
                  <ul className='blog-meta'>
                    <li className='date'>۰۵ فروردین</li>
                    <li>
                      <FaRegUser />  تیم تولید محتوا  
                    </li>
                    <li>
                      <FaRegFolderOpen /> مقاله
                    </li>
                  </ul>
                  <h5 className='mb-3'>
                    <div >
                    نکات مهم در انتخاب طرح مناسب برای گوشی موبایل
                    </div>
                  </h5>
                  <div className='read-more-text' >
                    اطلاعات بیشتر 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===================== BlogAreaTwo End =====================*/}
    </>
  );
};

export default BlogAreaTwo;
